import React from 'react';
import styled from 'styled-components';

export interface TabData {
    path: string;
    messageId: string;
    id: string;
}

export interface TabProps {
    active: boolean;
    children: React.ReactNode;
}

const TabItem = styled.li<{ active?: boolean }>`
    background: ${({ theme, active }) => (active ? theme.primaryDark : theme.defaultWhite)};
    border-bottom: ${({ theme, active }) => (active ? `1px solid ${theme.primaryMain}` : `1px solid ${theme.gray7}`)};
    color: ${({ theme, active }) => (active ? theme.defaultWhite : theme.primaryDark)};
    text-shadow: none;
    font-size: ${({ active }) => (active ? '16px' : '14px')};
    border-top: ${({ active }) => (active ? '' : 'none')};
    font-weight: 400;
    padding: 16px;
    width: 100%;
`;

const Tab: React.FC<TabProps> = ({ active, children }) => <TabItem active={active}>{children}</TabItem>;

export { Tab };
